/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
import classNames from 'classnames';
import type React from 'react';

import { type PolymorphicCommonProps } from '../_common/types';

/**
 *
 *
 * Types
 *
 *
 */

type LoadingSpinnerProps = {
  size?: 'small' | 'medium' | 'large';
};

/**
 *
 *
 * LoadingSpinner Component
 *
 *
 */

export const LoadingSpinner = <T extends React.ElementType = 'div'>({
  as,
  size = 'small',
  className,
  htmlAttributes,
  ref,
  ...restProps
}: PolymorphicCommonProps<T, LoadingSpinnerProps>) => {
  const Component: React.ElementType = as || 'div';
  const classes = classNames('ndl-spin-wrapper', className, {
    'ndl-large': size === 'large',
    'ndl-medium': size === 'medium',
    'ndl-small': size === 'small',
  });

  return (
    <Component
      className={classes}
      role="status"
      aria-label="Loading content"
      aria-live="polite"
      ref={ref}
      {...restProps}
      {...htmlAttributes}
    >
      <div className="ndl-spin" />
    </Component>
  );
};
